// @flow

import React, { PureComponent } from "react";
import styled, { keyframes } from "styled-components";
import buildColor from "@fdr/static-ui/ColorPalette";

const SVGContainer = styled.div`
  width: 100%;
`;

const pulseAnimation = keyframes`
  0% {
    fill: ${buildColor("grey", "100")};
  }

  50% {
    fill: ${buildColor("grey", "000")};
  }

  100% {
    fill: ${buildColor("grey", "100")};
  }
`;

const SVG = styled.svg`
  display: block;
  width: 100%;
  height: 720px;
  background: ${buildColor("white", "100")};

  rect.pulse {
    animation: ${pulseAnimation} 1.25s infinite;
  }

  rect.stroke {
    stroke: ${buildColor("grey", "200")};
    stroke-width: 1;
  }
`;

export default class RacesMask extends PureComponent<*> {
  render() {
    return (
      <SVGContainer data-qa-label="racesMask">
        <SVG>
          <g fill="none" fillRule="evenodd" transform="translate(0 1)">
            <rect width="518" height="58" fill="#FFF" />
            <rect
              width="91"
              height="45"
              x="12.5"
              y=".5"
              fill="#FFF"
              className="stroke"
              rx="4"
            />
            <rect
              width="91"
              height="45"
              x="112.5"
              y=".5"
              fill="#FFF"
              className="stroke"
              rx="4"
            />
            <rect
              width="25"
              height="16"
              x="20"
              y="8"
              fill="#F0F3F8"
              rx="1"
              className="pulse"
            />
            <rect
              width="53"
              height="16"
              x="120"
              y="8"
              fill="#F0F3F8"
              rx="1"
              className="pulse"
            />
            <rect
              width="40"
              height="8"
              x="20"
              y="30"
              fill="#F0F3F8"
              rx="1"
              className="pulse"
            />
            <rect
              width="40"
              height="8"
              x="120"
              y="30"
              fill="#F0F3F8"
              rx="1"
              className="pulse"
            />
            <rect
              width="91"
              height="45"
              x="212.5"
              y=".5"
              fill="#FFF"
              className="stroke"
              rx="4"
            />
            <rect
              width="53"
              height="16"
              x="220"
              y="8"
              fill="#F0F3F8"
              rx="1"
              className="pulse"
            />
            <rect
              width="40"
              height="8"
              x="220"
              y="30"
              fill="#F0F3F8"
              rx="1"
              className="pulse"
            />
            <rect
              width="91"
              height="45"
              x="312.5"
              y=".5"
              fill="#FFF"
              className="stroke"
              rx="4"
            />
            <rect
              width="91"
              height="45"
              x="412.5"
              y=".5"
              fill="#FFF"
              className="stroke"
              rx="4"
            />
            <rect
              width="53"
              height="16"
              x="320"
              y="8"
              fill="#F0F3F8"
              rx="1"
              className="pulse"
            />
            <rect
              width="53"
              height="16"
              x="420"
              y="8"
              fill="#F0F3F8"
              rx="1"
              className="pulse"
            />
            <rect
              width="40"
              height="8"
              x="320"
              y="30"
              fill="#F0F3F8"
              rx="1"
              className="pulse"
            />
            <rect
              width="40"
              height="8"
              x="420"
              y="30"
              fill="#F0F3F8"
              rx="1"
              className="pulse"
            />
          </g>
        </SVG>
      </SVGContainer>
    );
  }
}
